import { render, staticRenderFns } from "./CourtOrderAppLeaveGrantedPg.vue?vue&type=template&id=f36f1cf2&scoped=true"
import script from "./CourtOrderAppLeaveGrantedPg.vue?vue&type=script&lang=ts"
export * from "./CourtOrderAppLeaveGrantedPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36f1cf2",
  null
  
)

export default component.exports